import React from 'react'
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import styles from './styles.module.scss';

interface LinearProgressWithLabelProps {
    value: number;
}



const LinearProgressWithLabel: React.FC<LinearProgressWithLabelProps> = (props) => {
    return (
        <Box className={styles.container}>
            <Box className={styles.linearProgressContainer}>
                <LinearProgress variant="determinate" value={props.value}  />
            </Box>
            <Box minWidth={35}>
                <Typography
                    variant="body2"
                    color="textSecondary">
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}

export default LinearProgressWithLabel;